import React, { useState, useEffect } from "react";
import styles from "./AsnPage.module.css";
import "moment/locale/id";
import Header from "../../components/Header/Header";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { displayAlert } from "../../redux/actions/notif";
import AsnInputForm from "./AsnInputForm";
import AsnSearchForm from "./AsnSearchForm";
import * as apiAsn from "../../apis/asn"

const AsnPage = (props) => {
  const { displayAlert } = props;
  const [purchaseOrder, setPurchaseOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deliveryOptions, setDeliveryOptions] = useState([]);

  const getDeliveryOptions = async () => {
    try {
      setIsLoading(true);
      const { data } = await apiAsn.getDeliveryMethods();
      setDeliveryOptions(data?.data);
    } catch (error) {
      displayAlert({ type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDeliveryOptions();
  }, []);

  return (
    <div className={styles.container}>
      <Header activeKey="/asn" />
      <div className={styles.pageBody}>
        <AsnSearchForm
          displayAlert={displayAlert}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setPurchaseOrder={setPurchaseOrder}
          purchaseOrder={purchaseOrder}
        />
        <AsnInputForm
          deliveryOptions={deliveryOptions}
          visible={!!purchaseOrder}
          purchaseOrder={purchaseOrder}
          isLoading={isLoading}
          displayAlert={displayAlert}
          setIsLoading={setIsLoading}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      displayAlert: ({ message, type }) => displayAlert({ message, type }),
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AsnPage);
